<template>
  <li>
    <div class="details">
      <h3>
        {{ manager.name }} &ndash; {{ manager.company }}
        <span v-if="$vlastMode && manager.activation_notified_at" class="small">(Activation Email Sent: {{ manager.activation_notified_at | dateTimezone( $user.timezone, $user.date_format_preference, true, true) }})</span>
      </h3>
      <div class="row">
        <div class="col-xs-6 col-lg-3">
          <router-link tag="a" class="btn btn-sm btn-block btn-default" :to="{ name: 'managers.profile.show', params: { id: manager.id }}" exact>
            Profile
          </router-link>
        </div>
        <div class="col-xs-6 col-lg-3">
          <router-link tag="a" class="btn btn-sm btn-block btn-default" :to="{ name: 'managers.talent.index', params: { managerId: manager.id } }" exact>
            {{ $starLabelPlural | sentenceCase }}
          </router-link>
        </div>
        <div class="col-xs-6 col-lg-3">
          <router-link tag="a" class="btn btn-sm btn-block btn-default" :to="{ name: 'managers.requests.index', params: { managerId: manager.id } }" exact>
            Requests
          </router-link>
        </div>
        <div class="col-xs-6 col-lg-3">
          <router-link tag="a" class="btn btn-sm btn-block btn-default" :to="{ name: 'managers.bookings.index', params: { managerId: manager.id } }" exact>
            Bookings
          </router-link>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    manager: {
      required: true,
      type: Object
    }
  }
}
</script>
